export const formatNumber = (val: unknown) => {
  const formattedVal = typeof val !== null ? val : '';

  if (formattedVal) {
    return parseFloat((val as string).toString().replace(/[^\d.-]/g, ''));
  }
};
